// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"8c2408fa","790":"3a85b2fc"}[chunkId] + ".chunk.js";
};